export class InstitucionalItensDTO {

  constructor(
    public id?: string,
    public label?: string,
    public value?: number,
    public caminho?: string
  ) {
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/dominios/DTO/institucional-itens.DTO.ts